<template>
  <div class="row">
    <div class="col-md-9 col-12 pl-md-5 pr-md-5">
      <div class="row committee-wrp">
        <div class="col-md-12 mb-3 d-flex">
          <a
            @click="backRoute"
            class="mr-2 text-black"
            href="javascript:void(0)"
            ><i class="fas fa-arrow-left"></i
          ></a>
          <h5 class="text-uppercase" v-if="isEdit">
            {{
              committee.parent_id == 3
                ? "Bewerk commissie"
                : committee.parent_id == 2
                ? "Bewerk groep"
                : "Bewerk vereniging"
            }}
          </h5>
          <h5 class="text-uppercase" v-else>Nieuwe commissie</h5>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <div class="row">
              <div class="col-md-3">
                <img
                  :src="
                    img
                      ? img
                      : '/assets/img/blank-profile-picture-973460_640.png'
                  "
                  style="
                    height: 100px;
                    width: 100px;
                    margin-left: -8px;
                    margin-top: -8px;
                    border: 1px solid #ffffff;
                    border-radius: 50%;
                  "
                  alt=""
                />
              </div>
              <div class="col-md-9">
                <input
                  class="mt-4 custom-file-input"
                  type="file"
                  id="file"
                  @change="uploadImage"
                />
                <label for="file" class="btn-dark mt-4">
                  <span v-if="isEdit">Bewerk afbeelding</span>
                  <span v-else>Upload</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="name">Titel</label>
            <input type="text" class="form-control" id="name" v-model="title" />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="textarea">Omschrijving</label>
            <editor
              id="textarea"
              v-model="description"
              :init="{
                height: 200,
                menubar: false,
                language: 'nl',
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                ],
                toolbar:
                  'undo redo | formatselect | bold italic backcolor | \
                                    alignleft aligncenter alignright alignjustify | \
                                    bullist numlist outdent indent | removeformat | help',
              }"
            />
          </div>
        </div>
        <div class="col-md-12 mb-3">
          Kies leden
          <members
            v-bind:isEdit="isEdit"
            v-bind:committee="committee"
          ></members>
        </div>
        <div class="col-12 col-md-12">
          <div class="row">
            <h5 class="col-12">
              Indeling blokken <small>(Drag and Drop)</small>
            </h5>
            <div class="col-6">
              <draggable
                class="dragy"
                v-model="settings.blocks[0]"
                group="people"
                @start="drag = true"
                @end="drag = false"
              >
                <div
                  class="d-flex block"
                  v-for="element in settings.blocks[0]"
                  :key="element.id"
                >
                  <div class="d-flex">
                    <span class="mr-2"><i class="fas fa-bars"></i></span>
                    <span>{{ element.label }}</span>
                  </div>
                  <a
                    href="javascript:void(0)"
                    @click="toggleVisibility(element)"
                  >
                    <i v-if="element.visible" class="fas fa-eye text-green"></i>
                    <i v-else class="fas fa-eye-slash text-danger"></i>
                  </a>
                </div>
              </draggable>
            </div>
            <div class="col-6">
              <draggable
                class="dragy"
                v-model="settings.blocks[1]"
                group="people"
                @start="drag = true"
                @end="drag = false"
              >
                <div
                  class="d-flex block"
                  v-for="element in settings.blocks[1]"
                  :key="element.id"
                >
                  <div class="d-flex">
                    <span class="mr-2"><i class="fas fa-bars"></i></span>
                    <span>{{ element.label }}</span>
                  </div>
                  <a
                    href="javascript:void(0)"
                    @click="toggleVisibility(element)"
                  >
                    <i v-if="element.visible" class="fas fa-eye text-green"></i>
                    <i v-else class="fas fa-eye-slash text-danger"></i>
                  </a>
                </div>
              </draggable>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group mt-3">
              <label for="name">Beheerders:</label>
              <select2-multiple-control
                v-model="committeeAdministrators"
                :options="allUsers"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <button
            class="btn-dark float-right mt-3"
            v-if="isEdit"
            v-on:click="editCommittee"
          >
            Opslaan
          </button>
          <button
            class="btn-dark float-right mt-3"
            v-else
            v-on:click="createCommittee"
          >
            Opslaan
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import members from "../../committees/pages/members";
import draggable from "vuedraggable";
import { mapState, mapActions } from "vuex";
import Select2MultipleControl from "v-select2-multiple-component";

export default {
  components: {
    members,
    draggable,
    Select2MultipleControl,
  },
  props: ["isEdit", "committee", "parents_id"],
  data() {
    return {
      img: "",
      title: "",
      description: "",
      image: [],
      parent_id: "",
      active: 1,
      settings: {},
      committeeAdministrators: [],
      allUsers: [],
    };
  },
  methods: {
    ...mapActions({
      displayNotification: "auth/displayNotification",
    }),
    toggleVisibility(block) {
      block.visible = !block.visible;
    },
    backRoute() {
      this.$router.back();
    },
    uploadImage(event) {
      var file = event.target.files[0];
      this.image = file;
      this.img = URL.createObjectURL(file);
    },
    createCommittee() {
      const formData = new FormData();
      formData.append("img", this.image);
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("parent_id", 3);
      formData.append("active", this.active);
      formData.append(
        "administrators",
        JSON.stringify(this.committeeAdministrators)
      );
      formData.append("members", JSON.stringify(this.selectedMembers));

      var data = {
        endpoint: "/api/v1/committees",
        details: formData,
      };

      this.$store.dispatch("post", data).then((data) => {
        console.log(data);
        location.reload();
      });
    },
    editCommittee() {
      const formData = new FormData();
      formData.append("img", this.image);
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("active", this.active);
      formData.append("members", JSON.stringify(this.selectedMembers));
      formData.append(
        "administrators",
        JSON.stringify(this.committeeAdministrators)
      );
      formData.append("settings", JSON.stringify(this.settings));

      var data = {
        endpoint: "/api/v1/committees/update/" + this.committee.id,
        details: formData,
      };
      this.$store.dispatch("post", data).then((data) => {
        console.log(data);
        this.displayNotification({
          type: "success",
          title: "Success",
          message: "Successfully completed",
          id: Math.round(Math.random() * 999),
          autoDismiss: true,
          interval: 5000,
        });
      });
    },
    mergeSettings() {
      var settings = JSON.parse(this.committee.settings);
      var temp = { ...this.settings };
      var committee_blocks = [...settings.blocks[0], ...settings.blocks[1]];
      temp.blocks[0].forEach((element) => {
        if (committee_blocks.find((d) => d.label == element.label) == undefined)
          settings.blocks[0].push(element);
      });
      temp.blocks[1].forEach((element) => {
        if (committee_blocks.find((d) => d.label == element.label) == undefined)
          settings.blocks[1].push(element);
      });
      temp = { ...settings, ...temp };
      this.settings = { ...temp };

      let block1 = this.settings.blocks ? this.settings.blocks[0] : null;
      let block2 = this.settings.blocks ? this.settings.blocks[1] : null;

      if (block1) {
        block1 = block1.filter(
          (v, i, a) => a.findIndex((t) => t.order === v.order) === i
        );
        this.settings.blocks[0] = block1;
      }

      if (block2) {
        block2 = block2.filter(
          (v, i, a) => a.findIndex((t) => t.order === v.order) === i
        );
        this.settings.blocks[1] = block2;
      }
    },
  },
  computed: {
    ...mapState({
      selectedMembers: (state) => state.selectedMembers,
    }),
  },
  async created() {
    if (this.parents_id) {
      this.parent_id = this.parents_id;
    }
    this.settings = this.$store.state.committee_settings;
    let block1 = this.settings.blocks ? this.settings.blocks[0] : null;
    let block2 = this.settings.blocks ? this.settings.blocks[1] : null;

    if (block1) {
      block1 = block1.filter(
        (v, i, a) => a.findIndex((t) => t.order === v.order) === i
      );
      this.settings.blocks[0] = block1;
    }

    if (block2) {
      block2 = block2.filter(
        (v, i, a) => a.findIndex((t) => t.order === v.order) === i
      );
      this.settings.blocks[1] = block2;
    }

    await this.$store
      .dispatch("get", "/api/v1/users/all")
      .then((data) => {
        this.allUsers = data.data.data.map((item) => {
          return {
            id: item.id,
            text: item.display_name,
          };
        });
      })
      .catch((error) => {
        console.log(error.request);
      });

    if (this.committee.id != undefined) {
      this.committeeAdministrators = this.committee.administrators.map(
        (item) => {
          return item.id;
        }
      );
    }
  },
  watch: {
    isEdit: function() {
      if (this.isEdit) {
        this.title = this.committee.title;
        this.description = this.committee.description;
        this.img = this.committee.profile_image;
        this.parent_id = this.committee.id;

        if (this.committee.settings != null) {
          this.mergeSettings();
        }
      } else {
        this.title = "";
        this.description = "";
        this.img = "";
        if (this.committee.parent_id != 0) {
          this.parent_id = this.committee.parent_id;
        }
      }
    },
  },
};
</script>
<style scoped>
.dragy {
  background: #cfe4f67a;
  /* min-height: 200px;*/
  padding: 10px;
}
.block {
  justify-content: space-between;
  background: #d4e7f7;
  padding: 5px;
  margin-top: 5px;
  border-radius: 4px;
  border: 1px solid #d3d3d352;
}
.block:hover {
  cursor: move;
}
.block i.fa-bars {
  color: #65a7e2;
}
</style>
